module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/roles/components/role.modal.scss
// module id = 585
// module chunks = 1